export function challengeIdFrom(challenge) {
  const raw = challenge && (challenge._id || challenge.id);
  if (raw == null || raw === "") return "";
  const id = String(raw);
  if (!id || id === "undefined" || id === "null" || id === "[object Object]") {
    return "";
  }
  return id;
}

export function openChallengeResults(history, challenge) {
  const challengeId = challengeIdFrom(challenge);
  if (!challengeId) return;

  history.push({
    pathname: `/knowledge-challenge/results/${encodeURIComponent(challengeId)}`,
    state: {
      challengeId,
      name: challenge.name,
      winner: challenge.winner || null,
    },
  });
}

export function resolveResultsChallengeId({ challengeIdParam, search, state }) {
  let fromPath = "";
  if (challengeIdParam) {
    try {
      fromPath = decodeURIComponent(challengeIdParam);
    } catch (err) {
      fromPath = challengeIdParam;
    }
  }
  const fromQuery = search ? new URLSearchParams(search).get("id") || "" : "";
  const fromState = state && state.challengeId ? String(state.challengeId) : "";
  const usable = (value) =>
    value && value !== "undefined" && value !== "null" ? value : "";
  return usable(fromPath) || usable(fromQuery) || usable(fromState) || "";
}
